import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    requestSubmit: (context, data) => {
        return Axios.post((<any>window).App.routes.RentalMarine_Request, data);
    },
    getDealerPoints: (context, data) => {
        return Axios.post((<any>window).App.routes.RentalMarine_GetDealerPoints, data);
    },
    getRentalServiceData: (context, data) => {
        return Axios.post((<any>window).App.routes.RentalMarine_GetRentalServiceData, data);
    },
    getProvinces: (context, data) => {
        return Axios.post((<any>window).App.routes.RentalMarine_GetProvinces, data);
    },
    getPrivacyPolicy: (context, data) => {
        return Axios.post((<any>window).App.routes.RentalMarine_GetPrivacyPolicy, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};